<template>
    <!-- Modal Confirmando Envío de Cotización -->
<div class="modal" id="confirmCotizModal" tabindex="-1" role="dialog" aria-labelledby="confirmCotizModal" aria-hidden="true" >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" v-t="'confirm_modals.titulo_enviado'"></h5>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Cerrar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body modal-only-text">
              <img src="/img/gear.gif">
              <p  v-t="'confirm_modals.procesando'" >Estaremos procesando esta solicitud con brevedad.</p>
            </div>
            <div class="modal-footer">
              <a href="#0" class="material-btn bt_grey" role="button" data-bs-dismiss="modal" aria-label="Cerrar" v-t="'boton.cerrar'" >Cerrar</a>
            </div>
          </div>
        </div>
        </div>
</template>

<script>
export default {
  mounted(){ 
         $(document).ready(function() { 
    $('#confirmCotizModal').on('show.bs.modal', function (e) {
  document.getElementById('app').style.position = 'relative';
  });

$("#confirmCotizModal").on("hidden.bs.modal", function () {
    document.getElementById('app').style.position = 'fixed';
});
});
  },
  methods:{
    // Limpia la lista de vallas y los datos del formularios
    resetData(){

    }
  }
};
</script>

<i18n src="@/locale/modals/generic.json" />
<i18n src="@/locale/modals/confirmModals.json" />


